import moment from 'moment';
import { CONSTANTS } from 'services/constants';
import validate from 'validate.js';
import { isEmpty, isArray } from 'lodash';

validate.validators.emailObject = (value) =>
{
    if (isEmpty(value)) return null;

    const result = validate({ evaluate: value.value }, {
        evaluate: {
            email: true,
        },
    });

    return (typeof result !== 'undefined') ? ' is not a valid email.' : null;
};
validate.validators.emailList = (value, options) =>
{
    if (isEmpty(value)) return null;

    if (!isArray(value)) return 'must be a valid list';

    let invalids = [];

    value.forEach((val) =>
    {
        const toValidate = options.objectContent === true ? val.value : val;

        const result = validate({ evaluate: toValidate }, {
            evaluate: {
                email: true,
            },
        });
        if (typeof result !== 'undefined') invalids.push(toValidate);
    });

    return invalids.length === 0 ? null : ` is invalid. The Following emails are not valid: ${invalids.toString()}`; // eslint-disable-line consistent-return
};

validate.validators.equalsTo = (value, options) =>
{
    if (value !== options.value) return options.message;

    return null;
};

validate.validators.stringDateTime = (value, options) =>
{
    if (isEmpty(value)) return null;

    let finalFormat = CONSTANTS.FORMATS.DATETIME;
    let name = 'date and time';

    if (options.format)
    {
        const { format } = options;
        finalFormat = format;
        name = 'date';
    }
    else if (options.dateOnly)
    {
        finalFormat = CONSTANTS.FORMATS.DATE;
        name = 'date';
    }
    else if (options.timeOnly)
    {
        finalFormat = CONSTANTS.FORMATS.TIME;
        name = 'time';
    }

    return moment(value, finalFormat, true).isValid() ? null : `must be a valid ${name}`; // eslint-disable-line consistent-return
};

export default validate;
